module.exports = __webpack_public_path__ + "assets/blob-2-selected.f4ee4df3.svg";